import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";
import { haveValue } from "../helper/common";
import SkorList from "./tenant-profile/skorList";
import NewProperty from "./landlord/property/NewProperty";

const Home = () => {
  let location = useLocation();
  const { workspaceId } = useParams();
  const queryParameters = new URLSearchParams(window.location.search);
  const propId = queryParameters.get("propId");
  let propName = queryParameters.get("propName");
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user, loadMyNotifications } = authContext;
  const userType = localStorage.getItem("usertype");
  const [searchPropId, setSearchPropId] = useState(null);

  useEffect(() => {
    if (haveValue(propId)) setSearchPropId(propId);
  }, [propId, propName]);

  useEffect(() => {
    const searchParams = location.search ? location.search : "";

    if (user && (!user?.has_profile || !user?.profile_completed)) {
      navigate(
        user?.role === "landlord" && haveValue(workspaceId)
          ? `/${workspaceId}/home${searchParams}`
          : `/home${searchParams}`
      );
    } else {
      let userid = localStorage.getItem("saveduserid");
      if (user?._id) loadMyNotifications(userid, userType);
    }
    if (userType == "tenant" && location.pathname == "/") {
      navigate("/tenant");
    } else if (userType == "tenant") {
      navigate(`/home${searchParams}`);
    } else {
      const storedWorkspaceId = user?.workspaceIds?.[0]?.uuid;
      navigate(
        !workspaceId
          ? // ? `/${storedWorkspaceId}/home${searchParams}`
            `/workspace-dashboard`
          : `/${workspaceId}/home${searchParams}`
      );
    }
  }, []);

  if (userType === "landlord" || userType === "admin") {
    return (
      <>
        {user?.has_profile ? (
          <NewProperty
            propId={searchPropId}
            propName={propName}
            setSearchPropId={setSearchPropId}
          />
        ) : (
          haveValue(user) && navigate("/landlord/auth?profile_done=true")
        )}
      </>
    );
  }

  if (userType === "tenant") {
    return (
      <>
        <SkorList />
      </>
    );
  }
};
export default Home;
